import type { CustomStatusDto } from '@lagerfeuer/shared';

/** Gültiger eigener Status (abgelaufene werden ausgeblendet). */
export function activeCustomStatus(cs: CustomStatusDto | null | undefined, now = Date.now()): CustomStatusDto | null {
  if (!cs || (!cs.text && !cs.emoji)) return null;
  if (cs.expiresAt && new Date(cs.expiresAt).getTime() <= now) return null;
  return cs;
}
